import React, { useState, useRef, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import logo from '../../assets/img/Logo-Humano.png';
import { Formik } from 'formik';
import { ConsoleView, isBrowser } from "react-device-detect";
import { NavLink } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { get, post, getAnonymous, putFiles } from 'services';
import { connect } from 'react-redux';
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetLoading } from "redux/actions/loadingActions";
import { useHistory } from "react-router";
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import uuid from 'react-uuid';
import validateDominicanId from 'validacion-cedula-dominicana';
import BaseSelect from 'components/baseSelect';
import InputMask from "react-input-mask";

const Swal = require('sweetalert2');
let yup = require('yup');
 
const marginTopTen = {
    marginBottom: 10
}

const logoStyle = {
    ...marginTopTen,
    marginBottom: 10,
    width: 150,
    marginRight: 30
}

const minWidth = {
    minWidth: 1000,
    maxWidth: 1000
}

const loadingClases = {
    border: 'solid',
    borderRadius: '50%',
    borderRightColor: 'transparent'
}

const RegisterStepTwo = (props) => {
    const history = useHistory();
    const [formContent, setFormContent] = useState({
        identityDocument: '',
        identificationNumber:'',
        name: '',
        lastName: '',
        email: '',
    });
    const [linkedinPicture, setLinkedinPicture] = useState(null);
    const [reCAPTCHA, setReCAPTCHA] = useState('');
    const formRef = useRef();
    const [profilePicture, setProfilePicture] = useState(null);
    const schema = yup.object({
        identityDocument: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
        identificationNumber: yup.string()
        .when("identityDocument", {
            is: '1',
            then: yup.string().test('validateDominicanId', 'No es una cédula válida', val => validateDominicanId(String(val).replaceAll('-', '')))
        }).required("El campo es requerido"),
        name: yup.string().notRequired(),
        lastName: yup.string().notRequired(),
        email: yup.string().notRequired(),
    });
    const [dniTipoSelected, setDniTipoSelected] = useState(1);
    const [localUserData, setLocalUserData] = useState({});
    const [password, setPassword] = useState('');

    const getParams = (url) => {
        let params = {};
        let parser = document.createElement('a');
        parser.href = url;
        let query = parser.search.substring(1);
        let vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return (!params.hasOwnProperty('')) ? params : {};
    };

    const validateCedula = async () => {
        if (localUserData && localUserData.email) {
            const oldValues = formRef.current.values;
            const isCedula = oldValues.identityDocument == '1';
            let cedulaLimpia = isCedula ?  String(oldValues.identificationNumber).replaceAll('-', '') : oldValues.identificationNumber;
            const dto = {
                id: localUserData.email,
                cedula: cedulaLimpia
            }
            const response = await post(`Usuario/IsValidCedula`, dto);
            const EsCedulaExistente = response.data;
            if (EsCedulaExistente) {
                const msj = isCedula ? 'esa cédula' : 'ese pasaporte';
                Swal.fire({
                    icon: 'warning',
                    title: '¡Atención!',
                    text: '¡Ya existe un usuario registrado con '+ msj +', favor validar!'
                });
                return false;
            }
            if (isCedula && !validateDominicanId(cedulaLimpia)) {
                Swal.fire({
                    icon: 'warning',
                    title: '¡Atención!',
                    text: '¡No es una cédula válida!'
                });
                return false;
            }
            return true;
        }
    }

    const validateCedulaTienePersonaUsuario = async () => {
        if (localUserData && localUserData.email) {
            const oldValues = formRef.current.values;
            const isCedula = oldValues.identityDocument == '1';
            let cedulaLimpia = isCedula ?  String(oldValues.identificationNumber).replaceAll('-', '') : oldValues.identificationNumber;
            const dto = {
                cedula: cedulaLimpia
            }
            const response = await post(`Usuario/CedulaTienePersonaUsuario`, dto);
            const tienePersonaUsuario = response.data;

            return tienePersonaUsuario;
        }
    }



    const identityDocumentFilter = (data) => {
        return data.filter(x => x.id !== 3 && x.id !== 5);
    }

    useEffect(() => {
        (async function mounted() {
            const paramsObject = getParams(props.location.search);
            const hasParameters = Object.keys(paramsObject).length !== 0 && paramsObject.constructor === Object;
            if (hasParameters && ('token' in paramsObject)) {
                props.SetLoading(true);
                const response = await getAnonymous(`Usuario/ConfirmarUsuarioARSHumano?token=${paramsObject.token}`);
                
                if (response && response.data) {
                    const { tokenResponseDto, respuesta } = response.data;
                    
                    setPassword(tokenResponseDto.password)
                    
                    if (tokenResponseDto.foto) {
                        setLinkedinPicture(tokenResponseDto.foto);
                        fetch(tokenResponseDto.foto)
                            .then(res => res.blob())
                                .then(blob => {
                                    const mimeType = blob.type;
                                    const ext = mimeType.split('/')[1]
                                    const file = new File([blob], `${uuid()}.${ext}`, blob)
                                    setProfilePicture(file);
                                })
                    }

                    setFormContent({
                        name: tokenResponseDto.nombre,
                        lastName: tokenResponseDto.apellido,
                        email: tokenResponseDto.email,
                    });

                    setLocalUserData({
                        name: tokenResponseDto.nombre,
                        lastName: tokenResponseDto.apellido,
                        email: tokenResponseDto.email,
                    });

                    if (respuesta) {
                        Swal.fire({
                            icon: 'success',
                            title: '¡Correo validado correctamente!',
                            text: 'Favor ingresar su documento de identidad para completar el registro'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: '¡Error!',
                            text: 'Su usuario no ha sido validado'
                        });
                    }
                }

                //

                props.SetLoading(false);
            }
        })();
    }, [])

    const onSumitted = async (data) => {
        try {
            
            const isValid = await validateCedula();
            const tienePersonaUsuario = await validateCedulaTienePersonaUsuario();
            
            if (!isValid && tienePersonaUsuario) {
                return;
            }

            if(!isValid && !tienePersonaUsuario)
            {
                let foto;

                props.SetLoading(true);
            
                if (profilePicture) {
                    let imageFormData = new FormData();
                    imageFormData.append('file', profilePicture)
                    const response = await putFiles('PersonaDocumento/SaveProfileImage', imageFormData, "");
                    foto = response.data;
                }
                
                const usuario = {
                    clave: password,
                    persona: {
                        nombre: data.name,
                        apellido: data.lastName,
                        email: data.email, 
                        foto
                    },
                    recaptcha: reCAPTCHA,
                };
                
                const result = await post(`usuario/RegistroPersonaDB`, usuario);

                if (result && result.data) {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Usuario de la persona registrado correctamente!',
                        text: 'Acceda con sus credenciales'
                    });

                    history.push({
                        pathname: "/",
                        state: {}
                    });
                }
            }
            
            if(isValid && !tienePersonaUsuario)
            {

                let foto;

                props.SetLoading(true);

                const dniTipoId = Number(data['identityDocument']);
                const dniName = (dniTipoId == 1) ? String(data['identificationNumber']).replaceAll('-', '') : String(data['identificationNumber']);
            
                if (profilePicture) {
                    let imageFormData = new FormData();
                    imageFormData.append('file', profilePicture)
                    const response = await putFiles('PersonaDocumento/SaveProfileImage', imageFormData, "");
                    foto = response.data;
                }

                const usuario = {
                    clave: password,
                    persona: {
                        nombre: data.name,
                        apellido: data.lastName,
                        email: data.email, 
                        foto
                    },
                    recaptcha: reCAPTCHA,
                };
                
                const result = await post(`usuario/RegistroPersonaDB`, usuario);
                
                var personaDni = {
                    id: null,
                    personaId: result.data.persona.id,
                    estado: 1,
                    dniTipoId,
                    dni: dniName,
                    DniPrincipal: 1 
                };

                const r = await post(`PersonaDni/AddPersonaDni`, personaDni);

                if (result && result.data) {
                    Swal.fire({
                        icon: 'success',
                        title: '¡Usuario registrado correctamente!',
                        text: 'Acceda con sus credenciales'
                    });

                    history.push({
                        pathname: "/",
                        state: {}
                    });
                }
            }

        } catch (error) {
            console.log(error);
        } finally {
            props.SetLoading(false);
        }
    }

    return (
        <>
            {
                props.loading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner style={loadingClases} variant="primary" className={'is-absolute center-spinner-vertically'} animation="border" size="lg" />
                </div>
            }
            <div className="display-flex flex-center center-vertical flex-direction-column height-100 login-background">

                <div className={'padding-10'}>

                    <div style={!isBrowser ? {marginTop: 120} : null } className={'display-flex flex-end'}>
                        <img style={logoStyle} src={logo} alt="logo" />
                    </div>

                    <Card className="card-login">
                        <Card.Body style={isBrowser ? minWidth : null} className={'p-30'}>
                            <Row>
                                {
                                    linkedinPicture &&
                                    <Col xs={isBrowser ? 4 : 12}>
                                        <center>
                                            <Image style={{ height: isBrowser ? 270 : 150, width: isBrowser ? 270 : 150 }} src={linkedinPicture} fluid roundedCircle={true} />
                                        </center>
                                    </Col>
                                }
                                <Col xs={linkedinPicture ? isBrowser ? 8 : 12 : 12}>
                                    {
                                        <Formik
                                            innerRef={formRef}
                                            validationSchema={schema}
                                            onSubmit={onSumitted}
                                            initialValues={formContent}
                                            validateOnChange={false}
                                            validateOnBlur={false}
                                            enableReinitialize={true}
                                        > 
                                            {({
                                                handleSubmit,
                                                handleChange,
                                                handleBlur,
                                                values,
                                                touched,
                                                isValid,
                                                errors,
                                                setFieldValue
                                            }) => (
                                                <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                                                    <Form.Row>
                                                        <Form.Group as={Col} md="12" controlId="validationFormik02">
                                                            <Form.Label> <strong> Correo </strong> </Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                name="email"
                                                                value={values.email}
                                                                onChange={handleChange}
                                                                disabled={true}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.email}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group as={Col} md="6" controlId="validationFormik012">
                                                            <Form.Label> <strong> Nombre </strong> </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="name"
                                                                value={values.name}
                                                                onChange={handleChange}
                                                                disabled={true}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.name}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group as={Col} md="6" controlId="validationFormik02">
                                                            <Form.Label> <strong> Apellido </strong> </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lastName"
                                                                value={values.lastName}
                                                                onChange={handleChange}
                                                                disabled={true}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.lastName}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <BaseSelect
                                                            md={6}
                                                            errors={errors}
                                                            touched={touched}
                                                            handleChange={handleChange}
                                                            values={values}
                                                            label={'Documento Identidad'}
                                                            name={'identityDocument'}
                                                            url={'DniTipo/DniTipoSelect'}
                                                            hadFilder={true}
                                                            filteredData={identityDocumentFilter}
                                                            onSelected={data => setDniTipoSelected(data.id)}
                                                        /> 

                                                        <Form.Group as={Col} md="6" controlId="validationFormik02">
                                                            <Form.Label>Número</Form.Label>
                                                            { 
                                                                dniTipoSelected == 1 
                                                                ?   
                                                                    <Form.Control
                                                                        type="text"
                                                                        mask="999-9999999-9"
                                                                        as={InputMask}
                                                                        name="identificationNumber"
                                                                        value={values.identificationNumber}
                                                                        onChange={handleChange}
                                                                        onBlur={validateCedula}
                                                                        isValid={touched.identificationNumber && !errors.identificationNumber}
                                                                        isInvalid={!!errors.identificationNumber}
                                                                    />
                                                                :  
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="identificationNumber"
                                                                        value={values.identificationNumber}
                                                                        onChange={handleChange}
                                                                        isValid={touched.identificationNumber && !errors.identificationNumber}
                                                                        isInvalid={!!errors.identificationNumber}
                                                                    />
                                                            }
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.identificationNumber}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                    </Form.Row>

                                                    <ReCAPTCHA
                                                        sitekey={process.env.REACT_APP_NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                                                        onChange={setReCAPTCHA}
                                                        hl={'es'}
                                                    />

                                                    <div className={'display-flex flex-direction-column center-vertical'}>
                                                        <Button style={{marginTop: 15, width: '40%'}} disabled={reCAPTCHA == ''} variant={'dark'} type="submit"><strong>  Acceder </strong> </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    }
                                </Col>
                            </Row>



                        </Card.Body>
                    </Card>

                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        loading: state.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetUser: (user) => dispatch(SetUser(user)),
        SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
        SetLoading: (value) => dispatch(SetLoading(value))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps)(RegisterStepTwo);

